import React, { Component } from "react";

export default class InputContainer extends Component {
  render() {
    return <div className="form-group col-md-6">{this.props.children}</div>;
  }
}
